<template>
    <div>
        <!-- banner - 开始 -->
        <!-- :autoplay="false" -->
        <div :class="imgStatus == 0 ? '' : imgStatus == 1 ? 'loopTwoImg' : imgStatus == 2 ? 'loopOneImg' : ''">
            <el-carousel :class="['banner-wrap', banner <= 1 ? 'one-banner' : '']" height="520px" @change="carouselChange">
                <template v-if="banner > 0" v-for="data in bannerTwo">
                    <el-carousel-item>
                        <img :class="[
                            'banner-img',
                            data.url ? 'cursor-pointer' : '',
                        ]" @click="clickBanner(data)" :src="data.image" alt="" />
                    </el-carousel-item>
                </template>
            </el-carousel>
        </div>
        <!-- banner - 结束 -->

        <!-- 新闻中心、功能服务  - 开始 -->
        <div class="bgfff">
            <div class="pub-line flex content-box">
                <div class="news mr60">
                    <Title class="mb20" title="新闻中心" url="/news/15" />

                    <List-wrap :is-empty-list="$isEmptyList(newList)">
                        <List-item v-for="item in newList" :key="item.id" :item-info="item"
                            :url="item.category_id == 107 ? '/statistics/6/detail' : '/news/' + item.category_id + '/detail'" />
                    </List-wrap>
                </div>
                <div class="serve">
                    <Title title="功能服务" url="/vip">
                        <div class="member-center cursor-pointer">
                            <span>会员中心</span>
                        </div>
                    </Title>
                    <MemberCenter />
                </div>
            </div>
        </div>
        <!-- 新闻中心、功能服务  - 结束 -->

        <!-- 专业分会、协会活动、企业园地 - 开始 -->
        <div class="major-box">
            <div class="content-box">
                <div class="branch-box cursor-pointer">
                    <div class="index-branch-item" v-for="branch in branchList" :key="branch.id"
                        @click="branchClick(branch)">
                        <img :src="branch.image" alt="" />
                        <p>{{ branch.title }}</p>
                    </div>
                    <!-- <img class="new-20230829-img" src="../assets/images/20230829.jpg" alt=""> -->
                </div>
                <div class="active-enterprise flex">
                    <div class="active-box">
                        <Title class="mb20" title="协会活动" url="/news/16" />
                        <List-wrap :is-empty-list="$isEmptyList(associationList)">
                            <ActiveBox :associationList="associationList" style="cursor: pointer" />
                        </List-wrap>
                    </div>
                    <div class="enterprise-box">
                        <Title class="mb20" title="企业园地" url="/news/17" />
                        <div class="flex-left enterprise-item-box">
                            <EnterpriseItem v-for="item in enterpriseList" :data="item" :key="item.id"
                                style="cursor: pointer" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--专业分会、协会活动、企业园地 - 结束 -->

        <!-- 广告位banner - 开始 -->
        <Adv :category_id="2" />
        <!-- 广告位banner - 结束 -->

        <!-- 文件通知、重要通知 - 开始 -->
        <div class="bgfff">
            <div class="content-box notice-box">
                <div class="flex">
                    <div class="notice-file">
                        <Title class="mb20" title="文件通知" url="/association" />

                        <List-wrap :is-empty-list="$isEmptyList(fileList)">
                            <List-item v-for="item in fileList" :key="item.id" :item-info="item"
                                url="/association/detail?categoryId=19" />
                        </List-wrap>
                    </div>
                    <div class="notice-file">
                        <Title class="mb20" title="重要通知" url="/association" />

                        <List-wrap :is-empty-list="$isEmptyList(importantList)">
                            <List-item v-for="item in importantList" :key="item.id" :item-info="item"
                                url="/association/detail?categoryId=20" />
                        </List-wrap>
                    </div>
                </div>
                <div class="statistics-box flex" @click="statistics">
                    <router-link class="statistics-item" to="/statistics/1">
                        <img src="../assets/images/index-ydtjsj.png" alt="" />
                        <p style="text-shadow: 0px 2px 4px #426ABC;">月度统计数据</p>
                        <div>
                            <span style="cursor: pointer">查看详情</span>
                            <img src="../assets/images/index-tjdetail.png" alt="" />
                        </div>
                    </router-link>
                    <router-link class="statistics-item" to="/statistics/1/2">
                        <img src="../assets/images/index-jdtjsj.png" alt="" />
                        <p style="text-shadow: 0px 2px 4px rgba(73,154,176,0.71);">季度统计数据</p>
                        <div>
                            <span style="cursor: pointer">查看详情</span>
                            <img src="../assets/images/index-tjdetail.png" alt="" />
                        </div>
                    </router-link>
                    <router-link class="statistics-item" to="/statistics/1/3">
                        <img src="../assets/images/index-ndtjsj.png" alt="" />
                        <p style="text-shadow: 0px 2px 4px rgba(173,127,32,0.54);">年度统计数据</p>
                        <div>
                            <span style="cursor: pointer">查看详情</span>
                            <img src="../assets/images/index-tjdetail.png" alt="" />
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 文件通知、重要通知 - 结束 -->

        <!-- PTC ASIA展会 - 开始 -->
        <div class="exhibition-box">
            <div class="content-box">
                <Title class="mb20" title="PTC ASIA展会" url="/exhibition/index" target="_blank">
                    <div class="exhibition-more">展会页</div>
                </Title>
                <div class="flex">
                    <div class="exhibition-Events">
                        <Title2 title="展会动态" url="/exhibition/developments" />

                        <List-wrap :is-empty-list="$isEmptyList(exhibitionList)">
                            <List-item v-for="item in exhibitionList" :key="item.id" :item-info="item" target="_blank"
                                url="/exhibition/developments/detail" />
                        </List-wrap>
                    </div>
                    <div class="exhibition-right">
                        <a :href="exhibitionAdv.url || 'javascript:void(0);'" :style="{
                            cursor: exhibitionAdv.url ? 'pointer' : 'auto',
                        }" target="_blank">
                            <img :src="exhibitionAdv.image" alt="" />
                            <p>{{ exhibitionAdv.introduceStr }}</p>
                        </a>
                    </div>
                </div>
                <div class="exhibition-shows">
                    <Title2 title="精品展示" class="mb20" url="/exhibition/boutique" />
                    <List-wrap :is-empty-list="$isEmptyList(boutiqueList)">
                        <div class="flex-left exhibition-shows-item">
                            <div class="shows-item" v-for="item in boutiqueList" :key="item.id" @click="goToLink(item)"
                                style="cursor: pointer">
                                <img :src="item.image" alt="" />
                                <p>{{ item.title }}</p>
                                <p>{{ item.introduce }}</p>
                            </div>
                        </div>
                    </List-wrap>
                </div>
            </div>
        </div>
        <!-- PTC ASIA展会 - 结束 -->

        <!-- 培训通知、招聘信息、友情链接 -开始 -->
        <div class="bgfff">
            <div class="train-box content-box">
                <div class="flex">
                    <div class="">
                        <Title class="mb20" title="培训通知" url="/train/technicalTraining" />
                        <List-wrap :is-empty-list="$isEmptyList(enterpriseLists)">
                            <List-item v-for="item in enterpriseLists" :key="item.id" :item-info="item"
                                url="/train/technicalTraining/detail" />
                        </List-wrap>
                    </div>
                    <div>
                        <Title class="mb20" title="招聘信息" url="/personnel/information" />
                        <!-- <List-item
                    v-for="item in recruitList"
                    :key="item.id"
                    :item-info="item"
                    url="/personnel/information/detail"
                /> -->
                        <List-wrap :is-empty-list="$isEmptyList(recruitList)">
                            <List-item v-for="item in recruitList" :key="item.id" :item-info="item"
                                url="/personnel/information/detail" />
                        </List-wrap>
                    </div>
                </div>
                <FriendLink />
            </div>
        </div>
        <!-- 培训通知、招聘信息、友情链接 -结束 -->
    </div>
</template>
<script>
import ListWrap from "@/components/common/list-wrap.vue";
import Adv from "@/components/common/adv/singleSwiper.vue";
import Title from "@/components/common/title/title1.vue";
import ListItem from "@/components/common/list/list-item1.vue";
import MemberCenter from "@/components/index/memberCenter.vue";
import ActiveBox from "@/components/index/activeBox.vue";
import EnterpriseItem from "@/components/index/enterprise-item.vue";
import Title2 from "@/components/common/title/title2.vue";
import FriendLink from "@/components/index/friendLink.vue";
import { getadvinfo, getlist, getrecruitlist, addtotalviews } from "@/network/homeIndex";
import { gettrain } from "@/network/train";

export default {
    components: {
        Adv,
        Title,
        ListItem,
        MemberCenter,
        ActiveBox,
        EnterpriseItem,
        Title2,
        FriendLink,
        ListWrap,
    },
    data() {
        return {
            banner: 0,
            bannerTwo: [],
            imgStatus: 0,
            branchList: [], // 分会链接列表
            newList: "",
            associationList: [],
            enterpriseList: [],
            fileList: [],
            importantList: [],
            recruitList: [],
            boutiqueList: [],
            exhibitionList: [],
            exhibitionLists: [],
            exhibitionAdv: {},
            dataType: "",
            friendLink: [], // 友情链接
            pmdAnimate: false, // 友情链接跑马灯 切换时的动画
            pmdTimer: null, //  友情链接跑马灯 计时器
        };
    },
    computed: {
        optionLeft() {
            return {
                direction: 2,
                limitMoveNum: 2,
                openWatch: true,
            };
        },
    },
    mounted() {
        this.addtotalviews()
    },
    methods: {
        carouselChange(data) {
            if (this.banner == 2) {
                if (data == 0 || data == 1) {
                    //当为第一组数据的时候，打开当前的指示器，隐藏第二组数据的指示器
                    this.imgStatus = 1
                } else {
                    //当为第二组数据的时候，打开当前的指示器，隐藏第一组数据的指示器
                    this.imgStatus = 2
                }
            }
        },
        statistics() {
            // this.$message.error('敬请期待')
        },
        addtotalviews() {
            addtotalviews().then(res => {
            })
        },
        // 分会跳转详情
        branchClick(item) {
            if (item.url) {
                window.open(item.url);
            } else {
                this.$router.push({
                    path: "/Otherbranches",
                    query: { id: item.id },
                });
            }
        },
        clickBanner(item) {
            if (item.url) {
                window.open(item.url);
            }
        },
        goToLink(item) {
            if (item.url !== '') {
                window.open(item.url, "_blank");
            } else {
                let pathInfo = this.$router.resolve({
                    path: '/exhibition/boutique/detail?id=' + item.id,
                });
                window.open(pathInfo.href, "_blank");
            }
        },
        timestampToTime(timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return "";
            } else {
                var date = new Date(timestamp * 1000);
                var Y = date.getFullYear() + "/";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "/";
                var D =
                    date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                return Y + M + D;
            }
        },
    },
    created() {
        // 主轮播
        getadvinfo({
            category_id: 1,
            type: 0,
        }).then((res) => {
            if (res.data.length > 0) {
                this.banner = res.data.length;
                if (this.banner == 2) {
                    this.imgStatus = 1
                }
                if (res.data.length == 2) {
                    this.bannerTwo = [...res.data, ...res.data]
                    // this.bannerTwo.push(res.data[0], res.data[1])
                } else {
                    this.bannerTwo = res.data
                }
            }
        });

        // 主页展会展示图
        getadvinfo({
            category_id: 3,
            type: 0,
        }).then((res) => {
            let introduceStr = res.data.introduce.substr(0, 60);
            if (res.data.introduce.length > 60) {
                introduceStr = introduceStr + "...";
            }

            res.data.introduceStr = introduceStr;
            this.exhibitionAdv = res.data;
        });

        // 分会
        getadvinfo({
            category_id: 4,
            type: 0,
        }).then((res) => {
            if (res.data.length > 0) {
                this.branchList = res.data;
            }
        });

        // 友情链接
        getadvinfo({
            category_id: 5,
            type: 0,
        }).then((res) => {
            if (res.data.length > 0) {
                this.friendLink = res.data;
                this.$nextTick(() => {
                    this.pmdTimer = setInterval(this.setPmdAnmiate, 3000);
                });
            }
        });

        // 新闻中心
        getlist({
            category_id: 14,
            is_page: 0,
            is_main: 1,
        }).then((res) => {
            // res.data.data.sort((a, b) => {
            //     return b.createtimedate < a.createtimedate ? -1 : 1
            // })

            this.newList = res.data.data;
        });

        getlist({
            category_id: 16,
            is_page: 0,
            is_main: 0,
            page_num: 5,
        }).then((res) => {
            for (let index = 0; index < res.data.data.length; index++) {
                const element = res.data.data[index];
                element.category_id = 16
            }
            this.associationList = res.data.data || [];
        });
        gettrain({ page: 1, page_num: 10 }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            this.enterpriseLists = res.data.data || [];
            this.dataType = "train";
        });
        getlist({
            category_id: 17,
            is_page: 0,
            is_main: 0,
            page_num: 9
        }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            for (let index = 0; index < res.data.data.length; index++) {
                const element = res.data.data[index];
                element.category_id = 17
            }
            this.enterpriseList = res.data.data || [];
        });
        getlist({
            category_id: 19,
            is_page: 0,
            is_main: 0,
        }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            for (let index = 0; index < res.data.data.length; index++) {
                const element = res.data.data[index];
                element.category_id = 19
            }
            this.fileList = res.data.data || [];
        });
        getlist({
            category_id: 20,
            is_page: 0,
            is_main: 0,
        }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            for (let index = 0; index < res.data.data.length; index++) {
                const element = res.data.data[index];
                element.category_id = 20
            }
            this.importantList = res.data.data || [];
        });

        // 展会动态
        getlist({
            category_id: 57,
            is_page: 0,
            is_main: 0,
        }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            for (let index = 0; index < res.data.data.length; index++) {
                const element = res.data.data[index];
                element.category_id = 57
            }
            this.exhibitionList = res.data.data || [];
        });
        getlist({
            category_id: 58,
            is_page: 0,
            is_main: 0,
            page_num: 12,
        }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            for (let index = 0; index < res.data.data.length; index++) {
                const element = res.data.data[index];
                element.category_id = 58
            }
            this.boutiqueList = res.data.data || [];
        });

        // 培训通知
        getrecruitlist({ page: 1, page_num: 10 }).then((res) => {
            res.data.data.sort((a, b) => {
                return b.createtimedate < a.createtimedate ? -1 : 1
            })
            this.recruitList = res.data.data || [];
        });
    },
};
</script>
<style scoped  lang="less">
::v-deep .loopOneImg {
    .el-carousel__indicators {

        &>li:nth-child(1),
        &>li:nth-child(2) {
            display: none;
        }
    }
}

::v-deep .loopTwoImg {
    .el-carousel__indicators {

        &>li:nth-child(3),
        &>li:nth-child(4) {
            display: none;
        }
    }
}

.pub-line {
    padding-bottom: 60px;
}

.pub-line>div {
    flex: 1;
}

.news {
    min-width: 763px !important;
    max-width: 763px !important;
}

.member-center {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(-50%);
    width: 118px;
    line-height: 30px;
    background: url(~@/assets/images/member-center-btn-bg.png) center / contain no-repeat;
    color: #8b5316;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
}

.member-center span {
    background: linear-gradient(180deg, #ffffff 0%, #fde1e1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.major-box {
    background-color: #f6f7fb;
    padding: 60px 0 30px;
}

.branch-box {
    display: flex;
    margin-bottom: 20px;
}

.new-20230829-img {
    width: 1200px;
    height: 200px;
}

.index-branch-item {
    width: 270px;
    height: 200px;
    margin-right: 15px;
    background: #fff;
    font-size: 18px;
    color: #333333;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-between;
    border-radius: 8px;
    align-items: center;
    box-shadow: 0px 7px 26px 0px rgba(207, 207, 207, 0.31);
}

.index-branch-item:last-child {
    margin-right: 0;
}

.index-branch-item img {
    width: 100%;
    height: 140px;
    border-radius: 8px 8px 0 0;
    object-fit: cover;
}

.index-branch-item:hover {
    color: #0760a6;
}

.index-branch-item:hover img {
    border-bottom: 2px solid #008dd2;
}

.active-box {
    width: 512px;
}

.enterprise-box {
    width: 628px;
}

.enterprise-item-box {
    flex-wrap: wrap;
}

.notice-file {
    width: 570px;
}

.notice-box {
    padding-bottom: 60px;
}

.statistics-box {
    margin-top: 60px;
}

.statistics-box>div {
    width: 400px;
    height: 121px;
}

.statistics-item {
    position: relative;
    color: #fff;
}

.statistics-item>p {
    position: absolute;
    top: 25px;
    left: 40px;
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
    text-shadow: 0px 2px 4px #426abc;
}

.statistics-item::after {
    content: "";
    width: 40px;
    height: 2px;
    background: #fff;
    border-radius: 3px;
    position: absolute;
    top: 62px;
    left: 40px;
}

.statistics-item>div {
    position: absolute;
    right: 30px;
    bottom: 20px;
    width: 118px;
    height: 31px;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.statistics-item>div img {
    width: 17px;
    height: 16px;
}

.exhibition-box {
    background-color: #f6f7fb;
}

.exhibition-more {
    cursor: pointer;
    width: 84px;
    text-align: right;
    padding: 0 16px 0 0;
    border: 0;
    font-size: 16px;
    color: #6c6b76;
    font-weight: bold;
    background: url(~@/assets/images/arrow-right.png) right center / 16px no-repeat;
}

.exhibition-Events {
    width: 570px;
    margin-right: 60px;
}

.exhibition-shows {
    margin-top: 60px;
    padding-bottom: 30px;
}

.exhibition-shows-item {
    flex-wrap: wrap;
}

.exhibition-right {
    position: relative;
    width: 570px;
    height: 373px;
}

.exhibition-right img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.exhibition-right p {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 20px 16px 48%;
    background: linear-gradient(90deg,
            rgba(0, 193, 234, 0) 0%,
            rgba(0, 141, 209, 1) 100%);
    font-size: 12px;
    color: #3d4e66;
}

.shows-item {
    width: 285px;
    height: 378px;
    padding-top: 9px;
    padding-bottom: 30px;
    border-radius: 10px;
    background: #fff;
    text-align: center;
    margin-bottom: 30px;
    margin-right: 20px;
}

.shows-item:nth-child(4n) {
    margin-right: 0;
}

.shows-item img {
    width: 270px;
    height: 271px;
}

.shows-item p:nth-child(2) {
    margin-top: 22px;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: bold;
    color: #142d70;
    line-height: 1;
}

.shows-item p:nth-child(3) {
    font-size: 14px;
    color: #121126;
    line-height: 1;
}

.train-box {
    padding-bottom: 60px;
}

.train-box div.flex div {
    width: 570px;
}
</style>
